import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_5: FaireProductEntity = {
  token: "starter_collection_5",
  type: "product",
  name: "Perfectly Salty Chips",
  brandName: "Graza",
  imageUrl: "",
  priceDollars: 8,
  msrpDollars: 16,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
